import React, { useState, useEffect } from "react";
import "./alltransaction.scss";
import DataTable from "./DataTable/DataTable";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { Api_Url } from "../../../utils/ApiUrl";
import { useHistory } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Dropdown from "react-bootstrap/Dropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { DateRange } from "react-date-range";
import moment from "moment";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";

const AllTransaction = ({
  user,
  setindexwait,
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
}) => {
  const tok = localStorage?.getItem("accessToken");
  const [project, setProject] = useState("MINER");

  const [selectedItem, setSelectedItem] = useState({
    imgSrc: "/assets/minericon.svg",
    text: "MINER",
  });

  const handleItemClick = (imgSrc, text) => {
    setSelectedItem({ imgSrc, text });
    setProject(text);
  };

  const [leaderNames, setLeaderNames] = useState([]);

  const [transactionApiCalled, setTransactionApiCalled] = useState(false);

  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("transactionHashFilter");

  const [typeFilter, setTypeFilter] = useState("");
  const [orderField, setOrderField] = useState("transactionTime");
  const [orderDirection, setOrderDirection] = useState("-1");

  // const [tomiPrice, setTomiPrice] = useState("");

  const [claimsCSVData, setClaimsCSVData] = useState([]);
  const [claimsCSVDataHeaders, setClaimsCSVDataHeaders] = useState([]);
  const [loading, setLoading] = useState("");
  const [showbtn, setShowBtn] = useState(true);

  const [privateSaleFilter, setPrivateSaleFilter] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedLeaders, setSelectedLeaders] = useState([]);
  const [selectedWallets, setSelectedWallets] = useState([]);
  const [selectedAccessCodes, setSelectedAccessCodes] = useState([]);
  const [alllset, setalllset] = useState("all");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const [showcalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    formatDates("");
  }, []);

  useEffect(() => {
    if (usdPrice) {
      getTransactionsData();
    }
  }, [
    privateSaleFilter?.length,
    selectedItem?.text,
    usdPrice,
    user,
    search,
    typeFilter,
    orderField,
    orderDirection,
    page,
    startDate,
    endDate,
  ]);

  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };

  const getTransactionsData = () => {
    setTransactions([]);
    setTransactionApiCalled(true);

    var config = {
      method: "get",
      url: `${Api_Url}/nodeminer/transactions?privateSale=${project}&limit=10&offset=${
        page + 1
      }&orderField=transactionTime&orderDirection=-1`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };
    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }

    if (search) {
      dynamicQuery += `&search=${search}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.transactions);
        setTransactions(res?.data?.data?.transactions);
        setPageCount(res?.data?.data?.pages);
        setTransactionApiCalled(false);

        // setLoader(false);
      })
      .catch(function (error) {
        // setLoader(false);
        setTransactionApiCalled(false);
      });
  };

  const toastErrorFunc = () => {
    toast.error("No data found to export");
  };
  const getAllClaimsData = async () => {
    setLoading(true);
    setShowBtn(false);

    var config = {
      responseType: "stream",
      // get api so don't need to add useAdminAllowed();
      url: `${Api_Url}/users/bulk-admin-transaction-export`,
      data: {
        ...(selectedLeaders?.length > 0 && { nameFilter: selectedLeaders }),
        ...(selectedRoles?.length > 0 && { roleFilter: selectedRoles }),
        ...(search &&
          searchBy == "transactionHashFilter" && {
            transactionHashFilter: search,
          }),

        ...(selectedWallets?.length > 0 && {
          walletAddressFilter: selectedWallets,
        }),
        ...(selectedAccessCodes?.length > 0 && {
          accessCodeFilter: selectedAccessCodes,
        }),
        ...(privateSaleFilter?.length > 0 && {
          privateSaleFilter: privateSaleFilter,
        }),

        orderField: orderField,
        orderDirection: orderDirection,
      },
      headers: {
        Authorization: "Bearer " + tok,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await fetch(config.url, {
        method: "POST",
        body: JSON.stringify(config.data),
        headers: config.headers,
      });
      if (response.status == 429) {
        toast.error("Limit exceeded. Please try again in one minutes.");
        setTimeout(() => {
          setLoading(false);
          setShowBtn(true);
        }, 3000);
      }
      const reader = response.body.getReader();

      let oldData = "";

      while (true) {
        const { done, value } = await reader.read();
        // console.log(done, " done");

        if (done) {
          break;
        }
        oldData += new TextDecoder().decode(value);
      }
      try {
        const parsedData = JSON.parse(oldData);
        // console.log(parsedData, " parsed data");

        const dataForCsv = parsedData?.map((item) => {
          let date = moment(item?.transactionTime).format("DD/MM/YYYY");
          let time = moment(item?.transactionTime).format("hh:mm A");
          let name = item?.leader?.name;
          let role =
            item?.leader?.role === "mini_agent"
              ? "Ambassador"
              : item?.leader?.role === "god_agent"
              ? "God Leader"
              : item?.leader?.role === "super_agent"
              ? "Super Leader"
              : item?.leader?.role === "agent"
              ? "Leader"
              : item?.leader?.role === "mega_agent"
              ? "Mega Leader"
              : "";
          // let email = item?.location[0]?.recipientEmail;
          // let email = ""

          let code = item?.code_code;
          let Hash = item?.transactionHash;
          let walletAddress = item?.by;
          let price = item?.price;
          let paid = item?.totalSaleConverted;
          let amount = item?.dopPurchased;
          let payment = item?.amountInvested;
          let type = item?.type;
          return {
            date: date,
            time: time,
            name: name,
            role: role,
            // email: email,
            code: code,
            Hash: Hash,
            walletAddress: walletAddress,
            price: price,
            paid: paid,
            amount: amount,
            payment: payment,
            type: type,
          };
        });
        const headers = [
          { label: "date", key: "date" },
          { label: "time", key: "time" },
          { label: "name", key: "name" },
          { label: "role", key: "role" },
          { label: "customersEmail", key: "email" },

          { label: "code", key: "code" },
          { label: "Hash", key: "Hash" },
          { label: "walletAddress", key: "walletAddress" },
          { label: "price", key: "price" },
          { label: "paid", key: "paid" },
          { label: "amount", key: "amount" },
          { label: "payment", key: "payment" },
          { label: "type", key: "type" },
        ];
        setClaimsCSVData(dataForCsv);
        setClaimsCSVDataHeaders(headers);

        setLoading(false);
      } catch (error) {
        console.error("Error parsing JSON data:", error);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const functiontogetback = () => {
    localStorage.setItem("indexvalue", 0);
    setindexwait(0);
  };

  const [show3, setShow3] = useState(false);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);
  const handleCheckboxChangeLeaders = (leader) => {
    setSelectedLeaders(
      (prevLeaders) =>
        prevLeaders.some((l) => l.id === leader.id)
          ? prevLeaders.filter((l) => l.id !== leader.id) // Remove the leader object if already selected
          : [...prevLeaders, { id: leader.id, name: leader.name }] // Add the leader object if not selected
    );
  };

  const getAllEventKeys = (nodes, keys = []) => {
    nodes.forEach((node) => {
      keys.push(node._id.toString());
      Object.keys(node).forEach((key) => {
        if (Array.isArray(node[key]) && node[key].length > 0) {
          getAllEventKeys(node[key], keys);
        }
      });
    });
    return keys;
  };
  const areAllChildrenSelected = (node) => {
    const childNodes = getAllDescendantNodes(node);
    return childNodes.every((child) =>
      selectedLeaders.some((leader) => leader.id === child._id)
    );
  };

  const getAllDescendantNodes = (node) => {
    let descendants = [node];
    Object.keys(node).forEach((key) => {
      if (Array.isArray(node[key])) {
        node[key].forEach((child) => {
          descendants = descendants.concat(getAllDescendantNodes(child));
        });
      }
    });
    return descendants;
  };
  const handleParentCheckboxChange = (node) => {
    const allDescendants = getAllDescendantNodes(node);
    const descendantObjects = allDescendants.map((descendant) => ({
      id: descendant._id,
      name: descendant.name,
    }));

    let newSelectedLeaders;
    if (areAllChildrenSelected(node)) {
      // Deselect all descendants
      newSelectedLeaders = selectedLeaders.filter(
        (leader) => !descendantObjects.some((desc) => desc.id === leader.id)
      );
    } else {
      // Select all descendants
      newSelectedLeaders = [
        ...new Set([...selectedLeaders, ...descendantObjects]),
      ];
    }

    setSelectedLeaders(newSelectedLeaders);
  };
  const renderHierarchy = (nodes, level = 0) => {
    return nodes.map((node, index) => (
      <Accordion.Item
        key={`${node?._id}_${index}`}
        eventKey={node?._id?.toString()}
      >
        <Accordion.Header className={`accordion-header level-${level}`}>
          <div
            className="maininnerbtn"
            style={{ paddingLeft: `${level * 20}px` }}
          >
            <label className="cyberpunk-checkbox-label">
              <input
                type="checkbox"
                className="cyberpunk-checkbox"
                checked={areAllChildrenSelected(node)}
                onChange={() => handleParentCheckboxChange(node)}
              />
            </label>
            <div className="projectmain">
              <p className="projectpara">{node?.name}</p>
            </div>
          </div>
        </Accordion.Header>
        <Accordion.Body>
          {Object.keys(node).map((key) => {
            if (Array.isArray(node[key]) && node[key].length > 0) {
              return (
                <Accordion key={key} defaultActiveKey="0">
                  {renderHierarchy(node[key], level + 1)}
                </Accordion>
              );
            }
            return null;
          })}
        </Accordion.Body>
      </Accordion.Item>
    ));
  };

  const allEventKeys = getAllEventKeys(leaderNames);

  function convertToTitleCase(input) {
    // // console.log("cccc");
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );

      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }

  const formatDates = (times) => {
    let date = null;
    let date1 = null;
    if (Array.isArray(times)) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).format("Y-MM-DDT00:00:00");
      date1 = moment(b).format("Y-MM-DDT23:59:59");
    } else if (times == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    setStartDate(date);
    setEndDate(date1);
  };
  return (
    <>
      <section className="alltransaction">
        <div className="custom-container">
          {/* <button
            class="btn-back guvxgyvxvtxx"
            onClick={() => functiontogetback()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M8.37376 16.4675C8.20751 16.4675 8.04126 16.4062 7.91001 16.275L2.59876 10.9637C2.34501 10.71 2.34501 10.29 2.59876 10.0362L7.91001 4.72498C8.16376 4.47123 8.58376 4.47123 8.83751 4.72498C9.09126 4.97873 9.09126 5.39873 8.83751 5.65248L3.99001 10.5L8.83751 15.3475C9.09126 15.6012 9.09126 16.0212 8.83751 16.275C8.71501 16.4062 8.54001 16.4675 8.37376 16.4675Z"
                fill="black"
              ></path>
              <path
                d="M17.9375 11.1562H3.21124C2.85249 11.1562 2.55499 10.8587 2.55499 10.5C2.55499 10.1413 2.85249 9.84375 3.21124 9.84375H17.9375C18.2962 9.84375 18.5937 10.1413 18.5937 10.5C18.5937 10.8587 18.2962 11.1562 17.9375 11.1562Z"
                fill="black"
              ></path>
            </svg>{" "}
            Back
          </button>
          <div className="main-heading">
            <h6>All Transactions</h6>
            {user?.role == "god_agent" && user?.specialAccess?.length > 0 ? (
              <div className="set-twice-text">
                <div className="parent-toggle-switch-custom">
                  <div class="custom-toggle">
                    <input
                      type="checkbox"
                      class="checkbox"
                      id="checkbox"
                      checked={myTree}
                      onChange={(e) => {
                        setMyTree(e.target.checked);
                      }}
                    />
                    <label class="switch" for="checkbox">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <h6>Show data from my tree only</h6>
              </div>
            ) : null}
          </div>
          {user?.role == "admin" ? (
            <div className="bottom-cards">
              <div className="single-card">
                <img
                  src="\assets\dashboard\noofpurchases.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Number of Purchases</p>
                <h6>{adminobj?.TotalPurchases}</h6>
              </div>
              <div className="single-card">
                <img
                  src="/assets/incentive-purchased.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>INCENTIV Purchased</p>
                {adminobj?.totalDopPurchased ? (
                  <h6>
                    {parseInt(
                      (
                        tokenNftStats.stats[0]?.totalDopPurchased +
                        tokenNftStats.nftStats[0]?.totalDopPurchased
                      )?.toFixed(2)
                    ).toLocaleString("en-US")}{" "}
                    &nbsp;INC
                  </h6>
                ) : (
                  <h6>0.00 INC</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseFloat(
                          tokenNftStats?.stats[0]?.totalDopPurchased?.toFixed(4)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    Token
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseInt(
                          tokenNftStats?.nftStats[0]?.totalDopPurchased?.toFixed(
                            2
                          )
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p>
                </div>
              </div>
              <div className="single-card">
                <img
                  src="\assets\dashboard\purchasedamount.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Purchased Amount</p>
                {usdPrice && adminobj ? (
                  <h6 className="datahead">
                    ~$
                    {parseInt(
                      (
                        usdPrice * adminobj?.totalPurchaseEth +
                        adminobj?.totalPurchaseUsdt +
                        dopPrice * adminobj?.totalPurchaseDopToken +
                        btcPrice * adminobj?.totalPurchaseWbtc +
                        adminobj?.totalPurchaseUsdc +
                        pepePrice * adminobj?.totalPurchasePepe +
                        linkPrice * adminobj?.totalPurchaseLink +
                        uniPrice * adminobj?.totalPurchaseUni
                      )?.toFixed(2)
                    ).toLocaleString("en-US")}{" "}
                  </h6>
                ) : (
                  <h6 className="datahead">~$0.00 USD</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {adminobj ? adminobj?.totalPurchaseEth?.toFixed(4) : 0} ETH
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseUsdt?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseDopToken?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    DOP
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseWbtc?.toFixed(5)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    WBTC
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseUsdc?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchasePepe?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    PEPE
                  </p>{" "}
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseLink?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    LINK
                  </p>{" "}
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseUni?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    UNI
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="bottom-cards">
              <div className="single-card">
                <img
                  src="\assets\dashboard\noofpurchases.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Number of Purchases</p>
                {pdp?.length > 0 ? (
                  <h6>
                    {pdp[0]?.TotalPurchases > 0 ? pdp[0]?.TotalPurchases : 0}{" "}
                    <span className={pc > 0 ? "green-text" : "red-text"}>
                      {pc ? pc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6>0</h6>
                )}
              </div>
              <div className="single-card">
                <img
                  src="/assets/incentive-purchased.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>INCENTIV Purchased</p>
                {usdPrice && pdp ? (
                  <h6>
                    {pdp[0]?.totalDopPurchased > 0
                      ? parseFloat(pdp[0]?.totalDopPurchased)
                          .toFixed(2)
                          ?.toLocaleString("en-US")
                      : 0}
                    &nbsp;INC{" "}
                    <span className={dpc > 0 ? "green-text" : "red-text"}>
                      {dpc ? dpc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6>0.00 INC</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {dt[0]?.totalDirectDop
                      ? dt[0]?.totalDirectDop?.toFixed(4)
                      : 0}
                  </p>
                  <p className="uni-text">
                    <span></span>~
                    {ind[0]?.totalInDirectDop
                      ? ind[0]?.totalInDirectDop?.toFixed(4)
                      : 0}
                  </p>
                </div>
              </div>
              <div className="single-card">
                <img
                  src="\assets\dashboard\purchasedamount.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Purchased Amount</p>
                {(usdPrice && pee) || peu || (tomiPrice && pet) ? (
                  <h6 className="datahead">
                    {pee?.length > 0
                      ? "~$" +
                        parseFloat(
                          (
                            usdPrice *
                              (pee[0]?.totalPurchaseEth
                                ? pee[0]?.totalPurchaseEth
                                : 0) +
                            (peu[0]?.totalPurchaseUsdt
                              ? peu[0]?.totalPurchaseUsdt
                              : 0) +
                            tomiPrice *
                              (pet[0]?.totalPurchaseTomi
                                ? pet[0]?.totalPurchaseTomi
                                : 0) +
                            btcPrice *
                              (peBtc[0]?.totalPurchaseWbtc
                                ? peBtc[0]?.totalPurchaseWbtc
                                : 0) +
                            pepePrice *
                              (pePepe[0]?.totalPurchasePepe
                                ? pePepe[0]?.totalPurchasePepe
                                : 0) +
                            linkPrice *
                              (peLink[0]?.totalPurchaseLink
                                ? peLink[0]?.totalPurchaseLink
                                : 0) +
                            uniPrice *
                              (peUni[0]?.totalPurchaseUni
                                ? peUni[0]?.totalPurchaseUni
                                : 0) +
                            dopPrice *
                              (peUni[0]?.totalPurchaseDopToken
                                ? peUni[0]?.totalPurchaseDopToken
                                : 0)
                          )?.toFixed(4)
                        ).toLocaleString("en-US")
                      : 0}{" "}
                    <span className={pmc > 0 ? "green-text" : "red-text"}>
                      {pmc ? pmc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6 className="datahead">~$0.00 USD</h6>
                )}
                {pee?.length > 0 ? (
                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>
                      {pee[0]?.totalPurchaseEth
                        ? pee[0]?.totalPurchaseEth?.toFixed(4)
                        : 0}{" "}
                      ETH
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {peu[0]?.totalPurchaseUsdt
                        ? parseFloat(
                            peu[0]?.totalPurchaseUsdt?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      USDT
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {pet[0]?.totalPurchaseDopToken
                        ? parseFloat(
                            pet[0]?.totalPurchaseDopToken?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      DOP
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {peBtc[0]?.totalPurchaseWbtc
                        ? parseFloat(
                            peBtc[0]?.totalPurchaseWbtc?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      WBTC
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {peUsdc[0]?.totalPurchaseUsdc
                        ? parseFloat(
                            peUsdc[0]?.totalPurchaseUsdc?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      USDC
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {pePepe[0]?.totalPurchasePepe
                        ? parseFloat(
                            pePepe[0]?.totalPurchasePepe?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      PEPE
                    </p>{" "}
                    <p className="uni-text">
                      <span></span>
                      {peLink[0]?.totalPurchaseLink
                        ? parseFloat(
                            peLink[0]?.totalPurchaseLink?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      LINK
                    </p>{" "}
                    <p className="uni-text">
                      <span></span>
                      {peUni[0]?.totalPurchaseUni
                        ? parseFloat(
                            pet[0]?.totalPurchaseUni?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      UNI
                    </p>
                  </div>
                ) : (
                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>0 ETH
                    </p>
                    <p className="uni-text">
                      <span></span>0 USDT
                    </p>
                    <p className="uni-text">
                      <span></span>0 DOP
                    </p>
                    <p className="uni-text">
                      <span></span>0 WBTC
                    </p>
                    <p className="uni-text">
                      <span></span>0 USDC
                    </p>
                    <p className="uni-text">
                      <span></span>0 PEPE
                    </p>{" "}
                    <p className="uni-text">
                      <span></span>0 LINK
                    </p>{" "}
                    <p className="uni-text">
                      <span></span>0 UNI
                    </p>
                  </div>
                )}
              </div>
            </div>
          )} */}
          <div className="main-heading">
            <div>
              <p className="selfhead">Nodes & Miners</p>
              {user?.accessCode ? (
                <h6>All Transactions</h6>
              ) : (
                <h6>All Transactions</h6>
              )}
            </div>

            <div className="multi-items">
              <div className="rightside-content">
                <div className="custom-option-field" style={{ width: "575px" }}>
                  {/* <Dropdown className="positionset">
                    <Dropdown.Toggle id="dropdown-basic">
                      Hash
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                      >
                        <path
                          d="M0 0.5L2.22397e-07 3.0462L6.2 6.5L6.2 3.9538L0 0.5Z"
                          fill="#02171D"
                        />
                        <path
                          d="M12.3984 0.5L12.3984 3.0462L6.19844 6.5L6.19844 3.9538L12.3984 0.5Z"
                          fill="#02171D"
                        />
                      </svg>
                    </Dropdown.Toggle>
                  </Dropdown> */}
                  <input
                    // style={{ paddingLeft: "90px" }}
                    type="search"
                    placeholder="Search by Access Code, Wallet, Trx Hash..."
                    onChange={(e) => {
                      if (page != 0) {
                        setPage(0);
                      }
                      setSearch(e.target.value);
                    }}
                  />
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="img-fluid search-icon"
                  >
                    <path
                      d="M7.66671 14.5C3.90004 14.5 0.833374 11.4334 0.833374 7.66671C0.833374 3.90004 3.90004 0.833374 7.66671 0.833374C11.4334 0.833374 14.5 3.90004 14.5 7.66671C14.5 11.4334 11.4334 14.5 7.66671 14.5ZM7.66671 1.83337C4.44671 1.83337 1.83337 4.45337 1.83337 7.66671C1.83337 10.88 4.44671 13.5 7.66671 13.5C10.8867 13.5 13.5 10.88 13.5 7.66671C13.5 4.45337 10.8867 1.83337 7.66671 1.83337Z"
                      fill="black"
                    />
                    <path
                      d="M14.6666 15.1666C14.54 15.1666 14.4133 15.12 14.3133 15.02L12.98 13.6866C12.7866 13.4933 12.7866 13.1733 12.98 12.98C13.1733 12.7866 13.4933 12.7866 13.6866 12.98L15.02 14.3133C15.2133 14.5066 15.2133 14.8266 15.02 15.02C14.92 15.12 14.7933 15.1666 14.6666 15.1666Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="projectmain">
                      {selectedItem?.imgSrc && (
                        <img
                          src={selectedItem?.imgSrc}
                          alt="projectimg"
                          className="projectimg"
                          width={24}
                        />
                      )}
                      <p className="projectpara">{selectedItem?.text}</p>
                    </div>
                    <img
                      src="/assets/arrow-down.svg"
                      alt="arrow-down"
                      className="img-fluid"
                    />
                  </button>
                  <ul className="dropdown-menu">
                    {/* <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => handleItemClick("", "All Projects")}
                      >
                        All Projects
                      </a>
                    </li> */}

                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() =>
                          handleItemClick("/assets/nodeicon.svg", "NODE")
                        }
                      >
                        <div className="projectmain">
                          <img
                            src="/assets/nodeicon.svg"
                            alt="projectimg"
                            className="projectimg"
                            width={24}
                          />
                          <p className="projectpara">Node</p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() =>
                          handleItemClick("/assets/minericon.svg", "MINER")
                        }
                      >
                        <div className="projectmain">
                          <img
                            src="/assets/minericon.svg"
                            alt="projectimg"
                            className="projectimg"
                            width={24}
                          />
                          <p className="projectpara">Miner</p>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="custom-tab-bar">
                  <a
                    onClick={() => {
                      setalllset("1");

                      formatDates("1");
                    }}
                    className={alllset == "1" ? "active" : "noactive"}
                  >
                    1D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("seven");

                      formatDates("seven");
                    }}
                    className={alllset == "seven" ? "active" : "noactive"}
                  >
                    7D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("month");

                      formatDates("month");
                    }}
                    className={alllset == "month" ? "active" : "noactive"}
                  >
                    1M
                  </a>
                  <a
                    onClick={() => {
                      setalllset("year");

                      formatDates("year");
                    }}
                    className={alllset == "year" ? "active" : "noactive"}
                  >
                    1Y
                  </a>
                  <a
                    onClick={() => {
                      setalllset("all");

                      formatDates("");
                    }}
                    className={alllset == "all" ? "active" : "noactive"}
                  >
                    All
                  </a>
                  <a onClick={() => setShowCalendar(!showcalendar)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M17.0831 3.56V2C17.0831 1.59 16.7431 1.25 16.3331 1.25C15.9231 1.25 15.5831 1.59 15.5831 2V3.5H9.08312V2C9.08312 1.59 8.74311 1.25 8.33312 1.25C7.92312 1.25 7.58312 1.59 7.58312 2V3.56C4.88312 3.81 3.57311 5.42 3.37311 7.81C3.35311 8.1 3.59311 8.34 3.87311 8.34H20.7931C21.0831 8.34 21.3231 8.09 21.2931 7.81C21.0931 5.42 19.7831 3.81 17.0831 3.56Z"
                        fill="#8C8C8C"
                      />
                      <path
                        d="M20.3331 9.83984H4.33313C3.78313 9.83984 3.33313 10.2898 3.33313 10.8398V16.9998C3.33313 19.9998 4.83313 21.9998 8.33313 21.9998H16.3331C19.8331 21.9998 21.3331 19.9998 21.3331 16.9998V10.8398C21.3331 10.2898 20.8831 9.83984 20.3331 9.83984ZM9.54313 18.2098C9.49313 18.2498 9.44313 18.2998 9.39313 18.3298C9.33313 18.3698 9.27313 18.3998 9.21313 18.4198C9.15313 18.4498 9.09313 18.4698 9.03313 18.4798C8.96313 18.4898 8.90313 18.4998 8.83313 18.4998C8.70313 18.4998 8.57313 18.4698 8.45313 18.4198C8.32313 18.3698 8.22313 18.2998 8.12313 18.2098C7.94313 18.0198 7.83313 17.7598 7.83313 17.4998C7.83313 17.2398 7.94313 16.9798 8.12313 16.7898C8.22313 16.6998 8.32313 16.6298 8.45313 16.5798C8.63313 16.4998 8.83313 16.4798 9.03313 16.5198C9.09313 16.5298 9.15313 16.5498 9.21313 16.5798C9.27313 16.5998 9.33313 16.6298 9.39313 16.6698C9.44313 16.7098 9.49313 16.7498 9.54313 16.7898C9.72313 16.9798 9.83313 17.2398 9.83313 17.4998C9.83313 17.7598 9.72313 18.0198 9.54313 18.2098ZM9.54313 14.7098C9.35313 14.8898 9.09313 14.9998 8.83313 14.9998C8.57313 14.9998 8.31313 14.8898 8.12313 14.7098C7.94313 14.5198 7.83313 14.2598 7.83313 13.9998C7.83313 13.7398 7.94313 13.4798 8.12313 13.2898C8.40313 13.0098 8.84313 12.9198 9.21313 13.0798C9.34313 13.1298 9.45313 13.1998 9.54313 13.2898C9.72313 13.4798 9.83313 13.7398 9.83313 13.9998C9.83313 14.2598 9.72313 14.5198 9.54313 14.7098ZM13.0431 18.2098C12.8531 18.3898 12.5931 18.4998 12.3331 18.4998C12.0731 18.4998 11.8131 18.3898 11.6231 18.2098C11.4431 18.0198 11.3331 17.7598 11.3331 17.4998C11.3331 17.2398 11.4431 16.9798 11.6231 16.7898C11.9931 16.4198 12.6731 16.4198 13.0431 16.7898C13.2231 16.9798 13.3331 17.2398 13.3331 17.4998C13.3331 17.7598 13.2231 18.0198 13.0431 18.2098ZM13.0431 14.7098C12.9931 14.7498 12.9431 14.7898 12.8931 14.8298C12.8331 14.8698 12.7731 14.8998 12.7131 14.9198C12.6531 14.9498 12.5931 14.9698 12.5331 14.9798C12.4631 14.9898 12.4031 14.9998 12.3331 14.9998C12.0731 14.9998 11.8131 14.8898 11.6231 14.7098C11.4431 14.5198 11.3331 14.2598 11.3331 13.9998C11.3331 13.7398 11.4431 13.4798 11.6231 13.2898C11.7131 13.1998 11.8231 13.1298 11.9531 13.0798C12.3231 12.9198 12.7631 13.0098 13.0431 13.2898C13.2231 13.4798 13.3331 13.7398 13.3331 13.9998C13.3331 14.2598 13.2231 14.5198 13.0431 14.7098ZM16.5431 18.2098C16.3531 18.3898 16.0931 18.4998 15.8331 18.4998C15.5731 18.4998 15.3131 18.3898 15.1231 18.2098C14.9431 18.0198 14.8331 17.7598 14.8331 17.4998C14.8331 17.2398 14.9431 16.9798 15.1231 16.7898C15.4931 16.4198 16.1731 16.4198 16.5431 16.7898C16.7231 16.9798 16.8331 17.2398 16.8331 17.4998C16.8331 17.7598 16.7231 18.0198 16.5431 18.2098ZM16.5431 14.7098C16.4931 14.7498 16.4431 14.7898 16.3931 14.8298C16.3331 14.8698 16.2731 14.8998 16.2131 14.9198C16.1531 14.9498 16.0931 14.9698 16.0331 14.9798C15.9631 14.9898 15.8931 14.9998 15.8331 14.9998C15.5731 14.9998 15.3131 14.8898 15.1231 14.7098C14.9431 14.5198 14.8331 14.2598 14.8331 13.9998C14.8331 13.7398 14.9431 13.4798 15.1231 13.2898C15.2231 13.1998 15.3231 13.1298 15.4531 13.0798C15.6331 12.9998 15.8331 12.9798 16.0331 13.0198C16.0931 13.0298 16.1531 13.0498 16.2131 13.0798C16.2731 13.0998 16.3331 13.1298 16.3931 13.1698C16.4431 13.2098 16.4931 13.2498 16.5431 13.2898C16.7231 13.4798 16.8331 13.7398 16.8331 13.9998C16.8331 14.2598 16.7231 14.5198 16.5431 14.7098Z"
                        fill="#8C8C8C"
                      />
                    </svg>
                  </a>
                  {/* {showcalendar && ( */}
                  {showcalendar && (
                    <div className="cal set-custom-calendar-div">
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => {
                          // GetChartsDataCalendar([item.selection]);
                          // GetDashboardData([item.selection]);
                          formatDates([item.selection]);
                        }}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                      />
                    </div>
                  )}
                </div>

                {transactions?.length == 0 && (
                  <div className="upperbtn">
                    <button
                      onClick={toastErrorFunc}
                      className="downloadcsvcustombutton"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                      >
                        <path
                          d="M6 7.83334V11.8333L7.33333 10.5"
                          stroke="black"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.99984 11.8333L4.6665 10.5"
                          stroke="black"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.6668 7.16668V10.5C14.6668 13.8333 13.3335 15.1667 10.0002 15.1667H6.00016C2.66683 15.1667 1.3335 13.8333 1.3335 10.5V6.50001C1.3335 3.16668 2.66683 1.83334 6.00016 1.83334H9.3335"
                          stroke="black"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.6668 7.16668H12.0002C10.0002 7.16668 9.3335 6.50001 9.3335 4.50001V1.83334L14.6668 7.16668Z"
                          stroke="black"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Click To Export
                    </button>
                  </div>
                )}
                {transactions?.length != 0 && (
                  <div className="">
                    <div className="upperbtn">
                      {showbtn && (
                        <button
                          className="downloadcsvcustombutton"
                          onClick={getAllClaimsData}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              d="M6 7.83334V11.8333L7.33333 10.5"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M5.99984 11.8333L4.6665 10.5"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14.6668 7.16668V10.5C14.6668 13.8333 13.3335 15.1667 10.0002 15.1667H6.00016C2.66683 15.1667 1.3335 13.8333 1.3335 10.5V6.50001C1.3335 3.16668 2.66683 1.83334 6.00016 1.83334H9.3335"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14.6668 7.16668H12.0002C10.0002 7.16668 9.3335 6.50001 9.3335 4.50001V1.83334L14.6668 7.16668Z"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          Click To Export
                        </button>
                      )}
                      {loading ? (
                        <button className="mygreybtn">
                          <div className="text-center">
                            <div class="d-flex align-items-center justify-content-center">
                              <div
                                class="spinner-border text-info"
                                role="status"
                              >
                                <span class="sr-only"></span>
                              </div>
                            </div>
                          </div>
                        </button>
                      ) : (
                        <>
                          {claimsCSVData && claimsCSVData.length > 0 && (
                            <CSVLink
                              className="downloadcsvcustombutton"
                              data={claimsCSVData}
                              headers={claimsCSVDataHeaders}
                              filename={"Transactions_data.csv"}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                              >
                                <path
                                  d="M6 7.83334V11.8333L7.33333 10.5"
                                  stroke="black"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M5.99984 11.8333L4.6665 10.5"
                                  stroke="black"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M14.6668 7.16668V10.5C14.6668 13.8333 13.3335 15.1667 10.0002 15.1667H6.00016C2.66683 15.1667 1.3335 13.8333 1.3335 10.5V6.50001C1.3335 3.16668 2.66683 1.83334 6.00016 1.83334H9.3335"
                                  stroke="black"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M14.6668 7.16668H12.0002C10.0002 7.16668 9.3335 6.50001 9.3335 4.50001V1.83334L14.6668 7.16668Z"
                                  stroke="black"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Download CSV
                            </CSVLink>
                            // <CSVLink
                            //   data={claimsCSVData}
                            //   headers={claimsCSVDataHeaders}
                            //   filename={"Transactions_data.csv"}
                            //   className="mygreybtn"
                            // >
                            //   Download CSV
                            // </CSVLink>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <DataTable
            page={page}
            handlePageClick={handlePageChange}
            setSearch={setSearch}
            search={search}
            usdPrice={usdPrice}
            transactions={transactions}
            transactionApiCalled={transactionApiCalled}
            // setTransactions={setTransactions}
            pageCount={pageCount}
            user={user}
            setOrderDirection={setOrderDirection}
            setOrderField={setOrderField}
            tok={tok}
            selectedLeaders={selectedLeaders}
            selectedRoles={selectedRoles}
            searchBy={searchBy}
            selectedAccessCodes={selectedAccessCodes}
            selectedWallets={selectedWallets}
            privateSaleFilter={privateSaleFilter}
            orderDirection={orderDirection}
            orderField={orderField}
            project={selectedItem?.text}
          />

          <div className="footer-content mt-2">
            <div className="left-f">
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
            </div>
            <div className="right-f">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <nav aria-label="Page navigation example">
                    <ul class="text-center">
                      <ReactPaginate
                        previousLabel={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                          >
                            <path
                              d="M7.88904 1.93555L5.38763 1.93555L1.99459 7.99682L4.496 7.99682L7.88904 1.93555Z"
                              fill="#329879"
                            />
                            <path
                              d="M7.88904 14.0703L5.38763 14.0703L1.99459 8.00904L3.57108 6.96117L4.496 8.00904L7.88904 14.0703Z"
                              fill="#329879"
                            />
                            <path
                              d="M8.01655 6.85742H14.9616L13.6869 9.14313H6.74182L8.01655 6.85742Z"
                              fill="#329879"
                            />
                          </svg>
                        }
                        nextLabel={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                          >
                            <path
                              d="M9.11108 1.93555L11.6125 1.93555L15.0055 7.99682L12.5041 7.99682L9.11108 1.93555Z"
                              fill="#329879"
                            />
                            <path
                              d="M9.11108 14.0703L11.6125 14.0703L15.0055 8.00904L13.429 6.96117L12.5041 8.00904L9.11108 14.0703Z"
                              fill="#329879"
                            />
                            <path
                              d="M3.31318 6.85742H10.2582L8.98351 9.14313H2.03845L3.31318 6.85742Z"
                              fill="#329879"
                            />
                          </svg>
                        }
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName="pagination"
                        activeClassName="active"
                        forcePage={page}
                      ></ReactPaginate>
                    </ul>
                  </nav>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AllTransaction;
